import MultiCharacterThreeCanvas from './MultiCharacterThreeCanvas';
import useThreeNudgytAgentMultiCharacterCoreClient from '../../hooks/multi-character/useThreeNudgytAgentMultiCharacterCoreClient';

/**
 * Nudgyt Agent client for a multi-character Basic + Nudgyt Core simulation on
 * 3JS avatars. Mounted outside <Canvas> so the websocket stays alive when the
 * iframe is hidden.
 */
function ThreeNudgytAgentMultiCharacterClient() {
  const { client, talkingBotId, emotionsByBotId } =
    useThreeNudgytAgentMultiCharacterCoreClient();

  return (
    <MultiCharacterThreeCanvas
      client={client}
      talkingBotId={talkingBotId}
      emotionsByBotId={emotionsByBotId}
    />
  );
}

export default ThreeNudgytAgentMultiCharacterClient;
